/** One card of the mocked corp surface. Its own file, as the
 *  one-component-per-file rule has it. */
import { EM_DASH, KANBAN_STATUSES, heading, subtle } from './corp-mock';

export function InquiriesKanbanCard() {
  return (
    <section
      className="nb-card"
      style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
    >
      <div className="nb-card-hd">
        <h3 className="nb-display" style={heading}>
          Inquiries by Status
        </h3>
        <span className="nb-eyebrow">{EM_DASH} total</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 10 }}>
        {KANBAN_STATUSES.map((stage) => (
          <div
            key={stage}
            style={{
              display: 'flex',
              flexDirection: 'column',
              background: 'var(--nb-surface)',
              border: '1px solid var(--nb-border)',
              borderRadius: 8,
              padding: 8,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
              <i style={{ width: 8, height: 8, borderRadius: 999, background: subtle }} />
              <span style={{ fontSize: 10.5, fontWeight: 700, color: 'var(--nb-ink)' }}>
                {stage}
              </span>
              <span style={{ marginLeft: 'auto', fontSize: 10, color: subtle }}>{EM_DASH}</span>
            </div>
            <div
              style={{
                padding: '6px 8px',
                background: 'var(--nb-bg)',
                border: '1px solid var(--nb-border)',
                borderRadius: 5,
                fontSize: 11,
                color: subtle,
              }}
            >
              {EM_DASH}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
